import { useState } from "react";
import usePolling from "./usePolling";

export const useCachedStats = () => {
  const [cachedStats, setCachedStats] = useState({
    cpuUtilizationPastMonth: 0,
    cpuUtilizationPercentagePastMonth: 0,
    experimentCount: 0,
    experimentCountPastMonth: 0,
    gpuUtilizationPastMonth: 0,
    gpuUtilizationPercentagePastMonth: 0,
    storageUsage: 0,
    lastUpdated: null,
  });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const refreshCachedStats = usePolling(async (isActive) => {
    try {
      setLoading(true);
      const response = await fetch("/service/cluster-stats");
      if (!response.ok) {
        throw new Error(
          `Cluster stats API error: ${response.status} ${response.statusText}`,
        );
      }
      const data = await response.json();

      if (!isActive()) return;
      setCachedStats({
        lastUpdated: data.lastUpdated || null,
        cpuUtilizationPastMonth: data.cpuUtilizationPastMonth || 0,
        cpuUtilizationPercentagePastMonth:
          data.cpuUtilizationPercentagePastMonth || 0,
        experimentCount: data.experimentCount || 0,
        experimentCountPastMonth: data.experimentCountPastMonth || 0,
        gpuUtilizationPastMonth: data.gpuUtilizationPastMonth || 0,
        gpuUtilizationPercentagePastMonth:
          data.gpuUtilizationPercentagePastMonth || 0,
        storageUsage: data.storageUsage || 0,
      });
      setError(null);
    } catch (err) {
      if (!isActive()) return;
      console.error("Failed to fetch cached cluster stats:", err);
      setError(err);
    } finally {
      if (isActive()) setLoading(false);
    }
  }, 60 * 1000);

  return { cachedStats, loading, error, refreshCachedStats };
};
